<template>
  <div>
    <div class="h-full p-5">
      <el-form
        ref="form"
        label-width="120px"
        class="h-full overflow-y-auto"
        :model="adsMsg"
        :disabled="currentData.disabled"
        :rules="rules"
        @submit.native.prevent
      >
        <el-form-item
          label="广告组名称"
          prop="name"
        >
          <el-input
            v-model="adsMsg.name"
            placeholder="广告组名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="广告组状态">
          <el-switch
            v-model="adsMsg.status"
            active-text="开启"
            inactive-text="暂停"
            active-value="ENABLED"
            inactive-value="PAUSED"
          >
          </el-switch>
        </el-form-item>
        <!-- 竞价 -->
        <!-- <el-form-item
          label="竞价策略"
          prop="bidStrategy"
        >
          <el-radio-group
            v-model="adsMsg.bidStrategy"
            @change="changeBidStrategy"
          >
            <el-radio
              :label="item.value"
              v-for="item in enumConstants.bidStrategy"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <p v-if="adsMsg.campaignBidStrategy == 'AUTO' && adsMsg.bidStrategy == 'TARGET_CPA'" class="pl-[120px] mt-[-16px] text-[#ff0000]">系列出价方式为最大化价值转化，广告组目标出价不生效</p>
        <el-form-item
          label=""
          v-if="adsMsg.bidStrategy != 'AUTO'"
          prop="bidAmount"
        >
          <el-input
            v-model="adsMsg.bidAmount"
            placeholder="请输入出价金额"
            style="width: 240px"
            type="number"
            @change="changeBid"
          >
            <span slot="append">/转化</span>
          </el-input>
        </el-form-item> -->
        <p class="font-semibold text-[#666] text-[16px]">定向</p>
        <AudienceTarget
          v-model="adsMsg.groupCriterion.target"
          :enumConstants="enumConstants"
          :currentAccount="createAdAccount"
          location-label="地区"
          location-prop="groupCriterion.target.locations"
          language-label="语言"
          language-prop="groupCriterion.target.languages"
        />
         <p class="font-semibold text-[#666] text-[16px]"  v-if="showAdsetBid">广告组目标</p>
        <el-form-item label="" v-if="showAdsetBid">
            <AdsetBid  ref="adsetBid" :currentAccount="createAdAccount" :value="adsMsg" @input="(v) => setAdMsgEmit(v)" />
        </el-form-item>
        <p class="font-semibold text-[#666] text-[16px]">投放渠道</p>
        <el-form-item label="投放渠道">
          <ChannelType v-model="adsMsg.channelSetting" />
        </el-form-item>
        <p class="font-semibold text-[#666] text-[16px]">受众</p>
        <el-form-item label="受众群体">
          <AudienceGroup
            ref="audienceGroup"
            v-model="adsMsg.groupCriterion.audience.resourceName"
            :accountId="createAdAccount.id"
            :currentAccount="createAdAccount"
            :interestList="interestList"
            :audienceData="adsMsg.groupCriterion"
            :isEdit="true"
            @selectAudienceGroup="selectAudienceGroup"
          />
        </el-form-item>
        <el-form-item label="性别">
          <AudienceSex
            v-model="adsMsg.groupCriterion.audience.genders"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item label="年龄">
          <AudienceAge
            v-model="adsMsg.groupCriterion.audience.ageRange"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item label="自定义细分受众">
          <CustomAudience
            ref="customAudience"
            :currentAccount="createAdAccount"
            :disabled="true"
            v-model="adsMsg.groupCriterion.audience.customAudiences"
          />
        </el-form-item>
        <el-form-item label="兴趣和详细受众">
          <InterestAudience
            ref="interestAudience"
            v-model="adsMsg.groupCriterion.audience.userInterests"
            :list="interestList"
            :interestLabelSaveAPI="interestLabelSaveAPI"
            :countryCodes="adsMsg.groupCriterion.target.locations"
            :accountId="createAdAccount.id"
            :defaultExpandAll="false"
            :disabled="true"
          ></InterestAudience>
        </el-form-item>
        <el-form-item label="您的数据">
          <YourData
            ref="yourData"
            v-model="adsMsg.groupCriterion.audience.userLists"
            :currentAccount="createAdAccount"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item label="相似受众">
          <LikeAudience
            ref="likeAudience"
            v-model="adsMsg.groupCriterion.audience.lookalikeUserLists"
            :currentAccount="createAdAccount"
            :enumConstants="enumConstants"
            :data="data"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item label="优化型定位">
          <OptimizePosition
            :value="adsMsg"
            @input="(v) => setAdMsgEmit(v)"
          />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import AudienceAge from '@/views/google/create/components/audience/AudienceAge/index.vue';
import AudienceGroup from '@/views/google/create/components/audience/AudienceGroup/index.vue';
import InterestAudience from '@/views/google/create/components/audience/interestAudiences/index.vue';
import CreateSegmentAudience from '@/views/google/create/components/audience/createSegmentAudience/index.vue';
import OptimizePosition from '@/views/google/create/components/audience/OptimizePosition/index.vue';
import CustomAudience from '@/views/google/create/components/audience/CustomAudience/index.vue';
import AudienceSex from '@/views/google/create/components/audience/AudienceSex/index.vue';
import AudienceTarget from '@/views/google/create/components/audience/AudienceTarget/index.vue';
import ChannelType from '@/views/google/create/components/audience/ChannelType/index.vue';
import YourData from '@/views/google/create/components/audience/YourData/index.vue';
import LikeAudience from '@/views/google/create/components/audience/LikeAudience/index.vue';
import AdsetBid from '@/views/google/create/components/audience/AdsetBid/index.vue';
import { callToActionList, sexList } from '@/views/google/create/index.js';
import { adDetail, adConstMapGG, saveCommonInterests, updateAd } from '@/api/google/create.js';
import { mapState } from 'vuex';
export default {
  props: {
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    currentData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    createAdAccount: {
      type: Object,
      default: () => ({}),
    },
    interestList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      interestLabelSaveAPI: saveCommonInterests,
      adsMsg: {
        groupCriterion: {
          target: {},
          audience: {},
        },
      },
      checkData: {
        bidMin: 0.01,
        bidMax: 1000000,
      },
    };
  },
  components: {
    AudienceGroup,
    AudienceAge,
    InterestAudience,
    CreateSegmentAudience,
    OptimizePosition,
    CustomAudience,
    AudienceSex,
    AudienceTarget,
    ChannelType,
    YourData,
    AdsetBid,
    LikeAudience,
  },
  computed: {
    // 广告组出价区域是否展示：系列设置了有效出价值（TARGET_CPA/TARGET_ROAS）时显示
    showAdsetBid() {
      return ['TARGET_CPA', 'TARGET_ROAS'].includes(this.adsMsg.campaignBidStrategy);
    },
    rules() {
      return {
        name: [{ required: true, message: '广告组名称不能为空' }],
        'groupCriterion.target.locations': [
          {
            required: true,
            message: '请选择地区',
          },
          {
            validator(rule, value, callback) {
              if (value.length == 0) {
                return callback(new Error('请选择地区'));
              }
              callback();
            },
            trigger: ['blur'],
          },
        ],
        bidAmount: [
          {
            validator: (rule, value, callback) => {
              if (value && (value < this.checkData.bidMin || value > this.checkData.bidMax)) {
                return callback(new Error(`出价不能高于${this.checkData.bidMax} 不能低于${this.checkData.bidMin}`));
              } else if (!value) {
                return callback(new Error(`出价不能高于${this.checkData.bidMax} 不能低于${this.checkData.bidMin}`));
              }
              callback();
            },
            message: `出价在${this.checkData.bidMin}～${this.checkData.bidMax}区间`,
            trigger: ['blur', 'change'],
          },
        ],
        bidStrategy: [{ required: true, message: '请选择竞价类型', trigger: ['change', 'blur'] }],
      };
    },
  },
  watch: {
    currentData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.adsMsg = this.currentData;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async checkForm() {
      try {
        const validations = [this.$refs.form.validate()];

        // 只有当广告组目标出价组件存在时才校验
        if (this.$refs.adsetBid && this.showAdsetBid) {
          validations.push(Promise.resolve(this.$refs.adsetBid.validate()));
        }

        const results = await Promise.all(validations);
        return results.every((result) => result === true);
      } catch (error) {
        return false;
      }
    },
    /**统一数据更新方法 */
    setAdMsgEmit(v) {
      Object.assign(this.adsMsg, v);
    },
    // 设置广告组受众地区
    onChangeLocations(value, key) {
      console.log(this.enumConstants.countries);
      console.log(value);
      let location = this.enumConstants.countries.filter((v) =>
        value.map((key) => key.country_code).includes(v.country_code),
      );
      let languagesDefault = [...new Set(location.map((v) => v.defaultLanguageIds).flat())];
      this.$set(this.adsMsg.groupCriterion.target, 'languages', languagesDefault);
    },
    // 选择受众群体
    selectAudienceGroup(v) {
      console.log(v);
      if (v) {
        this.adsMsg.groupCriterion.audience = { ...this.adsMsg.groupCriterion.audience, ...v };
      } else {
        this.adsMsg.groupCriterion.audience = {
          ageRange: {
            minAge: 18,
            maxAge: null,
            undetermined: true,
          }, //年龄
          genders: ['UNDETERMINED', 'MALE', 'FEMALE'], // 性别
          languages: [], // 语言
          userInterests: [], // 兴趣词
          customAudience: [], // 自定义受众
          ...this.adsMsg.groupCriterion.audience,
        };
      }
    },
  },
  created() {
    this.$nextTick(() => {
      console.log(this.$refs.audienceGroup);
      this.$refs.audienceGroup.getAudienceGroupList();
      this.$refs.customAudience.getCustomAudienceList();
      this.$refs.yourData.getYourDataList();
      this.$refs.likeAudience.getLookalikeList();
    });
  },
};
</script>
<style lang="scss" scoped></style>
